import { useEffect } from "react";

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    window.scrollTo(0, 0);
  }, [title, description]);
}
